import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';
// declare var particlesJS: any;

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
})
export class AboutUsComponent implements OnInit, AfterViewInit {

  heading = "About Us";
  subheading = "Your Trusted Partner in Mobile App Security";
  innerWidth:number = window.innerWidth;

  @ViewChild('destination') destination?: ElementRef<HTMLElement>;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private metaTagService1: Meta,
    private route: ActivatedRoute,
    private canonicalService: CanonicalService
  ) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/about-us");
  }

  ngOnInit(): void {
    // particlesJS.load('particles-js', 'assets/particles.json', function() {});
    this.titleService.setTitle('About Us | Mobile App Security | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: 'Protectt.ai - Mobile Application Security Services | About Us'});
    this.metaTagService.updateTag({ name: 'description', content:'Protectt.ai is India’s first mobile security start up building awareness & providing solutions and services for mobile app, device & transaction security.',});
  }
  ngAfterViewInit() {
    this.route.fragment.subscribe((fragments) => {
      if (fragments == 'destination') {
        this.scrollToDestination();
      }
    });
  }
  scrollToDestination() {
    this.destination?.nativeElement.scrollIntoView();
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }
}
